import styled from 'styled-components'
import { desktopBreakpoint, tabletBreakpoint } from 'react-components'

export const Container = styled.div``

export const TitleContainer = styled.div`
    display: flex;
    line-height: 1.6;
    align-items: center;
    border-bottom: ${props => props.theme.typography.border.width.xxxThin} solid
        ${props => props.theme.colors.tfwBlackOpacity10};
    transition: padding 200ms ease-out;
    padding: 1rem 1rem 1rem 0rem;
    cursor: pointer;

    &:hover {
        border-bottom-color: ${props => props.theme.colors.tfwBlack87};
        padding: 1rem;
    }
`

export const Title = styled.div`
    width: 100%;
    font-weight: ${props => props.theme.typography.font.weight.normal};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.5rem;
`

export const DirectoryLink = styled.a`
    display: inline-block;
    padding: 0.5em 0;
    font: ${({ theme }) =>
        `${theme.typography.font.weight.normal} ${theme.typography.font.size.xSmall} / 1rem ${theme.typography.font.family.latoVerdana}`};
    text-decoration: none;
    transition: transform 0.2s;
    letter-spacing: 0.0125rem;
    color: #333;

    &:hover {
        transform: scale(1.02);
        text-decoration: underline;
        font-weight: ${({ theme }) => `${theme.typography.font.weight.bold}`};
    }
`

export const DirectoryLinkList = styled.ul`
    padding: 0.375rem 0;
    list-style: none;
    display: grid;
    gap: 0.5rem;
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        grid-template-columns: repeat(4, 1fr);
    }
`

export const InnerContainer = styled.div`
    padding: 0.313rem 0.625rem;
    background-color: #fafafa;
`
